(() => {
  'use strict';
  const keys = ['q', 'players', 'time', 'age', 'category', 'genre', 'difficulty', 'sort'];
  const normalize = value => String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const escape = value => String(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  function matches(game, state) {
    const haystack = normalize([game.name, ...game.categories, ...game.genres, game.summary].join(' '));
    return (!state.q || normalize(state.q).split(/\s+/).every(term => haystack.includes(term))) &&
      (!state.players || (game.playerMin !== null && game.playerMin <= +state.players && (game.playerMax === null || game.playerMax >= +state.players))) &&
      (!state.time || (game.timeMax !== null && game.timeMax <= +state.time)) &&
      (!state.age || game.age <= +state.age) &&
      (!state.category || game.categories.includes(state.category)) &&
      (!state.genre || game.genres.includes(state.genre)) &&
      (!state.difficulty || game.difficulty === +state.difficulty);
  }
  async function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    if (window.matchMedia('(min-width: 750px)').matches) root.querySelector('details').open = true;
    const form = root.querySelector('form'), results = root.querySelector('[data-results]'), count = root.querySelector('[data-count]'), more = root.querySelector('[data-more]'), dialog = root.querySelector('dialog');
    let games, filtered = [], limit = 24, opener;
    const state = () => Object.fromEntries(keys.map(key => [key, form.elements[key].value.trim()]));
    function paramsToForm() {
      const params = new URLSearchParams(location.search);
      keys.forEach(key => { form.elements[key].value = params.get('game_' + key) || (key === 'sort' ? 'az' : ''); });
    }
    const duration = g => g.time === 'varies' ? 'Time varies' : g.time + ' min';
    const stats = g => `<dl class="mh-game-stats"><div><dt>Players</dt><dd>${escape(g.players)}</dd></div><div><dt>Play time</dt><dd>${escape(duration(g))}</dd></div><div><dt>Ages</dt><dd>${g.age}+</dd></div></dl>`;
    const tags = g => g.categories.map(c => `<span class="mh-tag">${escape(c)}</span>`).join('');
    function card(g, i) {
      return `<article class="mh-game-card"><div class="mh-game-top"><span class="mh-game-number" aria-hidden="true">${String(i+1).padStart(2,'0')}</span><div class="mh-tags">${tags(g)}</div></div><h2><button type="button" data-game="${escape(g.id)}">${escape(g.name)} <span aria-hidden="true">↗</span></button></h2><p class="mh-game-summary">${escape(g.summary || 'Ask our team for an introduction to this game.')}</p>${stats(g)}<div class="mh-game-bottom"><span>Difficulty ${g.difficulty}/5</span><span class="mh-dots" aria-hidden="true">${'●'.repeat(g.difficulty)}${'○'.repeat(5-g.difficulty)}</span></div></article>`;
    }
    function render(updateURL = true, added = false) {
      const s = state();
      filtered = games.filter(g => matches(g, s));
      filtered.sort((a,b) => {
        if(s.sort === 'time') return (a.timeMax ?? Infinity) - (b.timeMax ?? Infinity) || a.name.localeCompare(b.name);
        if(s.sort === 'easy') return a.difficulty-b.difficulty || a.name.localeCompare(b.name);
        return a.name.localeCompare(b.name) * (s.sort === 'za' ? -1 : 1);
      });
      count.textContent = `${filtered.length} ${filtered.length === 1 ? 'game' : 'games'} found · ${Math.min(limit,filtered.length)} shown`;
      results.innerHTML = filtered.length ? filtered.slice(0, limit).map(card).join('') : '<div class="mh-empty"><h2>No games match just yet.</h2><p>Try a little more time or clear a filter to explore more of the shelves.</p><button type="button" class="mh-button" data-clear>Clear all filters</button></div>';
      more.hidden = limit >= filtered.length;
      more.textContent = `Show ${Math.min(24, filtered.length-limit)} more games`;
      if (added) results.querySelectorAll('[data-game]')[limit-24]?.focus();
      if(updateURL) {
        const url = new URL(location.href);
        keys.forEach(key => { const value=s[key]; if(value && !(key==='sort' && value==='az')) url.searchParams.set('game_'+key,value); else url.searchParams.delete('game_'+key); });
        history.replaceState(null, '', url);
      }
    }
    try {
      const response = await fetch(root.dataset.source);
      if (!response.ok) throw new Error('Game library unavailable');
      games = (await response.json()).games;
      if (!Array.isArray(games)) throw new Error('Invalid library');
      for(const [field, key] of [['category','categories'],['genre','genres']]) {
        [...new Set(games.flatMap(g => g[key]))].sort().forEach(value => form.elements[field].add(new Option(value,value)));
      }
      paramsToForm(); render(false);
    } catch(error) {
      count.textContent = 'The game library couldn’t load.';
      results.innerHTML = '<div class="mh-empty"><h2>Let’s give that another try.</h2><p>Please refresh the page, or ask our café team for a game recommendation.</p><button type="button" class="mh-button" data-retry>Try again</button></div>';
      results.querySelector('[data-retry]').addEventListener('click', () => { delete root.dataset.ready; init(root); });
      return;
    }
    form.addEventListener('submit', event => event.preventDefault());
    let debounce;
    form.addEventListener('input', () => { clearTimeout(debounce); debounce = setTimeout(() => {limit=24;render();},100); });
    form.addEventListener('change', () => { clearTimeout(debounce);limit=24;render(); });
    const clear = () => { keys.forEach(key => form.elements[key].value = key === 'sort' ? 'az' : ''); limit=24;render(); };
    form.addEventListener('reset', event => {event.preventDefault();clear();});
    more.addEventListener('click', () => { limit+=24;render(false,true); });
    root.querySelectorAll('[data-preset]').forEach(button => button.addEventListener('click', () => {
      clear();const preset=button.dataset.preset;
      if(preset==='two') form.elements.players.value='2';
      if(preset==='quick') form.elements.time.value='30';
      if(preset==='coop') form.elements.category.value='Co-op';
      if(preset==='family') form.elements.category.value='Family';
      render();
    }));
    results.addEventListener('click', event => {
      if(event.target.closest('[data-clear]')) {clear();form.elements.q.focus();return;}
      const button=event.target.closest('[data-game]');if(!button)return;
      const game=games.find(g=>g.id===button.dataset.game);opener=button;
      root.querySelector('[data-detail]').innerHTML=`<p class="mh-eyebrow">Meet your next game</p><div class="mh-tags">${tags(game)}</div><h2>${escape(game.name)}</h2><p>${escape(game.summary || 'Ask our team for an introduction to this game.')}</p>${stats(game)}<p><strong>Difficulty:</strong> ${game.difficulty}/5</p><p><strong>Genres:</strong> ${escape(game.genres.join(', ') || 'Ask our team')}</p>`;
      dialog.showModal();
    });
    dialog.querySelector('.mh-close').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('click', event => { if(event.target===dialog) {const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left || event.clientX>rect.right || event.clientY<rect.top || event.clientY>rect.bottom)dialog.close();} });
    dialog.addEventListener('close',()=>opener?.focus());
    window.addEventListener('popstate',()=>{ if(root.isConnected){paramsToForm();limit=24;render(false);} });
  }
  const boot = scope => scope.querySelectorAll('[data-mh-library]').forEach(init);
  boot(document);
  document.addEventListener('shopify:section:load',event=>boot(event.target));
})();
